module.exports = __webpack_public_path__ + "img/close.4b90c3f1.png";